import React from 'react';
import { useDragLayer } from 'react-dnd';
import { ItemTypes } from 'constants/reactDnDItemTypes';
import MatchingChoicePreview from './MatchingChoicePreview';

export const CustomDragLayer = () => {
  const { itemType, isDragging, item, currentOffset } = useDragLayer(
    monitor => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }),
  );
  const renderMatchingChoice = () => {
    if (itemType !== ItemTypes.MATCHING) return null;
    return <MatchingChoicePreview {...item} />;
  };
  if (!isDragging) {
    return null;
  }
  return (
    <div className="MatchingMatchBank-Preview">
      <div
        style={{
          transform: `translate(${currentOffset?.x}px, ${currentOffset?.y}px)`,
        }}
      >
        {renderMatchingChoice()}
      </div>
    </div>
  );
};
